import CardDocument from 'components/CardDocument';
import HorizontalCard from 'components/HorizontalCard';
import MainButton from 'components/MainButton';
import Layout from 'Layout'
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getDocuments, getDocByKategori, getKategoriDoc, searchDoc } from 'services/apiRoutes';
import SkeletonCardDocument from 'skeletons/SkeletonCardDocument';
import ImDoc from 'assets/images/ImDoc.jpg'

export default function DocumentGampong() {
  const {slug} = useParams()
  const [doc,setDoc]=useState();

  const [kategori, setKategori] = useState();

  const [loading,setLoading]= useState(false);
  const [active,setActive]=useState();
  const [defaultKategori,setDefaultKategori]=useState(true);


  const [keyword,setKeyword] = useState();

  const docAPI = useCallback(
    async (limit, offset) => {
      setLoading(true);
      const res = await getDocuments(limit, offset,slug);
      if (res.error) {
        return res.message;
      } else {
        setLoading(false);
        const { data } = res.data;
        setDoc(data);
        setDefaultKategori(true);
        setActive(null);
      }
    },
    [slug]
  );

    const docKategoriAPI = useCallback(async () => {
      const res = await getKategoriDoc(slug);
      if (res.error) {
        return res.message;
      } else {
        const { data } = res.data;
        setKategori(data);
      }
    }, [slug]);
  
    const docByKategoriAPI = useCallback(async (uuid,indexBtn) => {
      setLoading(true);
      const res = await getDocByKategori(20,0,uuid,slug);
      if (res.error) {
        return res.message;
      } else {
        setLoading(false);
        const { data } = res.data;
        setDoc(data);
        setActive(indexBtn);
        setDefaultKategori(false);

      }
    }, [slug]);

    const searchDocAPI = useCallback(async (limit,offset,keyword) => {
      setLoading(true);
      const res = await searchDoc(limit,offset,keyword,slug);
      if (res.error) {
        return res.message;
      } else {
        setLoading(false);
        const { data } = res.data;
        setDoc(data);
      }
    }, [slug]);

    const seacrhDoc = () => {
      searchDocAPI(100,0,keyword);
    };

        const handleKeypress = (e) => {
          if (e.key === "Enter") {
              searchDocAPI(100, 0, keyword);
          }
        };


  useEffect(() => {
    docAPI(10, 0);
    docKategoriAPI();
  }, [docAPI, docKategoriAPI, keyword]);

  const navigate = useNavigate();
  return (
    <Layout active="dokumen">
      <div className="px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Dokumen Gampong
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Dokumen Gampong"
            img={ImDoc}
          />
        </div>
        <div className="mt-[78px] font-bold text-sm">Cari dokumen:</div>
        <input
          type="text"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyPress={handleKeypress}
          placeholder="Cari Dokumen"
          className="px-5 py-3 my-4 border seacrh rounded-2xl focus:outline-none xl:w-[994px] mr-4 w-full focus:ring-2 focus:ring-primary focus:border-none"
        />
        <MainButton label="Cari" onClick={() => seacrhDoc()} />
        {doc?.length !== 0 ? null : (
          <h1 className="font-bold">{`"${keyword}" Tidak Ditemukan`}</h1>
        )}
        <div className="flex mt-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden">
          <div className="text-sm font-bold">Filter</div>
          {kategori
            ? kategori.map((item, index) => (
                <MainButton
                  activeBtn={active === index ? true : false}
                  secondType
                  label={item?.nama}
                  key={index}
                  onClick={() => docByKategoriAPI(item.uuid, index)}
                />
              ))
            : null}

          <MainButton
            secondType
            activeBtn={defaultKategori}
            label="Semua"
            key={53653635}
            onClick={() => docAPI(10, 0)}
          />
        </div>
        <div className="grid-cols-3 gap-1 my-20 xl:grid wrapperDoc">
          {loading
            ? [1, 2, 3, 4].map((x) => <SkeletonCardDocument key={x} />)
            : doc?.map((item, index) => (
                <CardDocument
                  key={index}
                  title={item.nama}
                  date={item.create_date}
                  writer={item.list_kategori_dokumen_obj?.[0]?.kategori_obj?.nama}
                  onClick={() => navigate(`/${slug}/documents/${item.uuid}`)}
                />
              ))}
        </div>
      </div>
    </Layout>
  );
}
